/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ConversationModel } from "./ConversationModel";
import type { EventModel } from "./EventModel";
import type { PaginationModel } from "./PaginationModel";

export interface ConversationResponse {
  conversation: ConversationModel;
  messages: EventModel[];
  pagination: PaginationModel;
}
